import { captureException } from "@sentry/react";
import { useConnection } from "@solana/wallet-adapter-react";
import { ZetaPositionFetcher } from "@stepfinance/dex/src/lib/positions";
import { useEffect, useMemo, useState } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useMarkets } from "../../contexts/market";
import type { MarginAccount } from "../../types/margin";
import { getMarginPositionIcon } from "../../utils/margin";
import { getTokenByMint } from "../../utils/tokenInfo";

let timer;
export const useZetaMarkets = () => {
  const { publicKey, connected } = useEnrichedWallet();
  const { connection } = useConnection();
  const { priceInUSD, marketsInitialised } = useMarkets();
  const [marginAccounts, setMarginAccounts] = useState<MarginAccount[]>([]);

  useEffect(() => {
    setMarginAccounts([]);
  }, [connected]);

  const fetcher = useMemo(() => {
    if (!publicKey) {
      return undefined;
    }
    return new ZetaPositionFetcher(publicKey, connection, getTokenByMint, getMarginPositionIcon);
  }, [connection, publicKey]);

  useEffect(() => {
    if (fetcher && marketsInitialised) {
      clearTimeout(timer);
      timer = setTimeout(
        () =>
          fetcher
            .fetchPositions(priceInUSD)
            .then((result) => result && setMarginAccounts(result))
            .catch((error) => {
              console.error("Zeta Markets Error: ", error);
              captureException(error);
            }),
        300,
      );
    }
  }, [marketsInitialised, priceInUSD, fetcher]);
  return {
    marginAccounts,
  };
};
